var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowNext(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.68629 20.6863C1.68571 27.9303 1.68571 36.0697 4.68629 43.3137C7.68687 50.5578 13.4422 56.3131 20.6863 59.3137C27.9303 62.3143 36.0697 62.3143 43.3137 59.3137C50.5578 56.3131 56.3131 50.5578 59.3137 43.3137C62.3143 36.0697 62.3143 27.9303 59.3137 20.6863C56.3131 13.4422 50.5578 7.68687 43.3137 4.68629C36.0697 1.68571 27.9303 1.68571 20.6863 4.68629C13.4422 7.68687 7.68688 13.4422 4.68629 20.6863Z",
    fill: "#FDE400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 22L44 32L36 42",
    stroke: "black",
    strokeWidth: 1.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 32L36 32",
    stroke: "black",
    strokeWidth: 1.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowNext);
export default __webpack_public_path__ + "static/media/yellowNext.a2bc00e2af85ffd404706b9995684793.svg";
export { ForwardRef as ReactComponent };